type Props = {};

const InsightTemplatePdfFooter = (props: Props) => {
    // pdf footer is empty for now
    return null;
};

export default InsightTemplatePdfFooter;
